export default "__VITE_ASSET__4c468b3b__"